import { Navigate } from 'react-router-dom';

import { useAuthContext } from '@myphx-engineering/auth/client';

import { getAbsoluteRoute } from '../../../util/get-absolute-route';

import { MedicationsDeliveredHeader } from './MedicationsDeliveredHeader';
import { UnauthHomeFooter } from './UnauthHomeFooter';
import { WhyChooseLilly } from './WhyChooseLilly';

const UnauthHomePage = () => {
    const { isAuthenticated } = useAuthContext();

    if (isAuthenticated) {
        return <Navigate to={getAbsoluteRoute('home')} replace />;
    }

    return (
        <>
            <MedicationsDeliveredHeader />
            <WhyChooseLilly />
            <UnauthHomeFooter />
        </>
    );
};

export default UnauthHomePage;
